import React from "react";
import { Accordion } from "semantic-ui-react";
import Icon from "semantic-ui-react/dist/commonjs/elements/Icon";
import List from "semantic-ui-react/dist/commonjs/elements/List";
import Checkbox from "semantic-ui-react/dist/commonjs/modules/Checkbox";
import { AclAction, AclResource } from "../../../../types/acl";
import { FineGrainedPermission, Permission } from "../../../../types/permissions";
import { Role } from "../../../../types/roles";
import { exists } from "../../../../utils/utils";
import Action from "./Action";

type ResourceProps = {
  onChange?: (change: any) => any;
  permissions: Permission[];
  resource: AclResource;
  canEdit: boolean;
  fineGranularity?: any[];
  fineGrainedPermissions: FineGrainedPermission[];
  role: Role | Record<string, never>;
};

type ResourceState = { open: boolean; isActive: boolean } & Record<number, boolean>;

class Resource extends React.PureComponent<ResourceProps, ResourceState> {
  actions = this.props.permissions
    .filter(
      permission =>
        permission.aclAction !== undefined && permission.resourceId === this.props.resource.id
    )
    .map(permission => ({ ...(permission.aclAction as AclAction), id: permission.id }));

  constructor(props: ResourceProps) {
    super(props);
    const isActive =
      this.props.role.aclResourcesActions &&
      this.props.role.aclResourcesActions.filter(
        permission => permission.resourceId === this.props.resource.id
      ).length > 0;
    const checkedActions = this.actions.reduce<Record<number, boolean>>((obj, action) => {
      obj[action.id] = exists(
        props.role.aclResourcesActions?.find(permission => permission.id === action.id)
      );
      return obj;
    }, {});
    this.state = { ...checkedActions, open: false, isActive: isActive ?? false };
  }

  checkAction = (newAction: number, isChecked: boolean) => {
    this.setState({ [newAction]: isChecked });
    const activeActions =
      this.actions.filter(action => newAction !== action.id && this.state[action.id]).length > 0;
    if (!isChecked && !activeActions) {
      this.setState({ isActive: false, open: false });
    }

    this.props.onChange?.({
      role: this.props.role.id,
      permission: this.props.permissions?.find(permission => permission.id === newAction)?.id
    });
  };

  toggleActive = (event: any) => {
    event.stopPropagation();
    if (!this.props.canEdit) return;
    const newIsActive = !this.state.isActive;
    if (newIsActive) {
      this.actions.forEach(action => {
        if (!this.state[action.id]) {
          this.props.onChange?.({
            role: this.props.role.id,
            permission: action.id
          });
        }
        this.setState({ [action.id]: true });
      });
      this.setState({ isActive: newIsActive, open: true });
      return;
    }
    this.actions.forEach(action => {
      if (this.state[action.id]) {
        this.props.onChange?.({
          role: this.props.role.id,
          permission: action.id
        });
      }
      this.setState({ [action.id]: false });
    });
    this.setState({ isActive: newIsActive, open: false });
  };

  handleClick = () => {
    const newOpen = this.state.isActive && !this.state.open;
    this.setState({ open: newOpen });
  };

  aLittlePaddingLeft = { paddingLeft: "10px" };
  disabled = {
    color: "var(--grey)"
  };

  render() {
    return (
      <>
        <Accordion.Title
          index={this.props.role.id + this.props.resource.id}
          active={this.state.open}
          onClick={this.handleClick}
          style={!this.state.isActive ? this.disabled : null}
        >
          <Icon name="dropdown" />
          <b>{this.props.resource.title}</b>
          <Checkbox
            aria-label="Resource checkbox"
            disabled={!this.props.canEdit}
            style={{ float: "right", transform: "scale(0.7)" }}
            checked={this.state.isActive}
            onClick={this.toggleActive}
            toggle
          />
        </Accordion.Title>
        <Accordion.Content active={this.state.open}>
          <List style={this.aLittlePaddingLeft}>
            {this.actions.map(action => (
              <Action
                canEdit={this.props.canEdit}
                key={this.props.role.id + this.props.resource.id + action.id}
                action={action}
                role={this.props.role}
                resource={this.props.resource}
                checked={this.state[action.id]}
                onActionChange={this.checkAction}
                fineGranularity={this.props.fineGranularity}
                fineGrainedPermissions={this.props.fineGrainedPermissions}
              />
            ))}
          </List>
        </Accordion.Content>
      </>
    );
  }
}
export default Resource;
